module.exports = __webpack_public_path__ + "static/2-af733bfb57dcea7e57f35ec75a811556.jpg";